module.exports = __webpack_public_path__ + "static/instagram-23177b448a4e2c2391aec76cc3b724df.png";